const customIcons = {
  values: {
    search: {
      type: "icon",
      icon: "fas fa-search",
    },
    howToCite: {
      type: "icon",
      icon: "fas fa-link",
    },
    PublicationCitation: {
      type: "icon",
      icon: "fas fa-book-open",
    },
    createdAt: {
      type: "icon",
      icon: "fas fa-folder-plus",
    },
    updatedAt: {
      type: "icon",
      icon: "fas fa-sync",
    },
    tools: {
      type: "icon",
      icon: "fas fa-tools",
    },
    contacts: {
      type: "icon",
      icon: "fas fa-envelope",
    },
    maintains: {
      type: "icon",
      icon: "fas fa-sitemap",
    },
    funds: {
      type: "img",
      icon: "/assets/icons/fund-icon.png",
    },
    collaborates_on: {
      type: "icon",
      icon: "fas fa-handshake",
    },
    other_involvement: {
      type: "icon",
      icon: "fas fa-building",
    },
    undefined: {
      type: "icon",
      icon: "fas fa-question",
    },
    arrowUp: {
      type: "icon",
      icon: "fas fa-chevron-up",
    },
    data_access: {
      type: "icon",
      icon: "fas fa-key",
    },
    data_curation: {
      type: "icon",
      icon: "fas fa-database",
    },
    data_release: {
      type: "icon",
      icon: "fas fa-recycle",
    },
    data_versioning: {
      type: "icon",
      icon: "fas fa-sync",
    },
    nodes: {
      type: "img",
      icon: "/assets/icons/nodes.png",
    },
    licences: {
      type: "icon",
      icon: "fas fa-certificate",
    },
    certificate: {
      type: "img",
      icon: "/assets/icons/certificate-badge.svg",
    },
    frequently_asked_questions_faqs: {
      type: "icon",
      icon: "fas fa-question-circle",
    },
    forum: {
      type: "icon",
      icon: "fas fa-comment",
    },
    help_documentation: {
      type: "icon",
      icon: "fas fas fa-book",
    },
    blog_news: {
      type: "icon",
      icon: "fas fa-newspaper",
    },
    twitter: {
      type: "icon",
      icon: "fab fa-twitter",
    },
    wikipedia: {
      type: "icon",
      icon: "fab fa-wikipedia-w",
    },
    github: {
      type: "icon",
      icon: "fab fa-github",
    },
    facebook: {
      type: "icon",
      icon: "fab fa-facebook",
    },
    training_documentation: {
      type: "icon",
      icon: "fas fa-funnel-dollar",
    },
    tess_links_to_training_materials: {
      type: "img",
      icon: "/assets/icons/elixir-tess.png",
    },
    support_email: {
      type: "icon",
      icon: "fas fa-headset",
    },
    collection: {
      type: "img",
      icon: "/assets/records/collection-icon.svg",
      tooltip: "Collection",
    },
    journal: {
      type: "img",
      icon: "/assets/records/policy.svg",
      tooltip: "Journal",
    },
    identifier_schema: {
      type: "img",
      icon: "/assets/records/identifier_schema.svg",
      tooltip: "Identifier Schema",
    },
    society: {
      type: "img",
      icon: "/assets/records/policy.svg",
      tooltip: "Society",
    },
    funder: {
      type: "img",
      icon: "/assets/records/policy.svg",
      tooltip: "Funder",
    },
    project: {
      type: "img",
      icon: "/assets/records/policy.svg",
      tooltip: "Project",
    },
    institution: {
      type: "img",
      icon: "/assets/records/policy.svg",
      tooltip: "Institution",
    },
    terminology_artefact: {
      type: "img",
      icon: "/assets/records/terminology_artefact.svg",
      tooltip: "Terminology Artefact",
    },
    model_and_format: {
      type: "img",
      icon: "/assets/records/model_and_format.svg",
      tooltip: "Model and Format",
    },
    reporting_guideline: {
      type: "img",
      icon: "/assets/records/reporting_guideline.svg",
      tooltip: "Reporting Guideline",
    },
    metric: {
      type: "img",
      icon: "/assets/records/metric.svg",
      tooltip: "Metric",
    },
    benchmark: {
      type: "img",
      icon: "/assets/records/benchmark.svg",
      tooltip: "Benchmark",
    },
    principle: {
      type: "img",
      icon: "/assets/records/principle.svg",
      tooltip: "Principle",
    },
    repository: {
      type: "img",
      icon: "/assets/records/db-icon.svg",
      tooltip: "Repository",
    },
    journal_publisher: {
      type: "img",
      icon: "/assets/records/policy.svg",
      tooltip: "Journal Publisher",
    },
    knowledgebase: {
      type: "img",
      icon: "/assets/records/db-icon.svg",
      tooltip: "Knowledge Base",
    },
    knowledgebase_and_repository: {
      type: "img",
      icon: "/assets/records/db-icon.svg",
      tooltip: "Knowledge Base & repository",
    },
    DOI: {
      type: "img",
      icon: "/assets/icons/DOI_logo.svg",
    },
    Orcid: {
      type: "img",
      icon: "/assets/icons/ORCID_iD.svg",
    },
    mailing_list: {
      type: "icon",
      icon: "fas fa-address-book",
    },
    contact_form: {
      type: "icon",
      icon: "fas fa-address-card",
    },
    recommended: {
      type: "icon",
      icon: "fas fa-thumbs-up",
    },
    video: {
      type: "icon",
      icon: "fas fa-video",
    },
    collections: {
      type: "img",
      icon: "/assets/Home/BlockInfo/collection-icon.svg",
    },
    educational: {
      type: "icon",
      icon: "fas fa-graduation-cap",
    },
    api: {
      type: "icon",
      icon: "fas fa-laptop-code",
    },
    home_standard: {
      type: "img",
      icon: "/assets/Home/BlockInfo/home-standards.svg",
    },
    home_db: {
      type: "img",
      icon: "/assets/Home/BlockInfo/home-db.svg",
    },
    home_policies: {
      type: "img",
      icon: "/assets/Home/BlockInfo/home-policies.svg",
    },
    other: {
      type: "icon",
      icon: "fas fa-ellipsis-h",
    },
    adopters: {
      type: "icon",
      icon: "fas fa-file-alt",
    },
    activities: {
      type: "icon",
      icon: "fas fa-chart-line",
    },
    governance: {
      type: "icon",
      icon: "fas fa-university",
    },
    linkedin: {
      type: "icon",
      icon: "fab fa-linkedin",
    },
    home: {
      type: "icon",
      icon: "fas fa-home",
    },
    user: {
      type: "icon",
      icon: "fas fa-user",
    },
    users: {
      type: "icon",
      icon: "fas fa-users",
    },
    collaborators: {
      type: "icon",
      icon: "fas fa-users-cog",
    },
    info: {
      type: "icon",
      icon: "fas fa-info",
    },
  },
  iconfont: "fa",
};

export default customIcons;
